import {
  fetchDictList,
  fetchFileTypeList,
} from "@/api/common"
import {fetchCustomerList} from '@/api/customer'

export default {
  data() {
    return {
      shipid: 0,
      fd: {
        id_code: null,
        inspection_reg_num: null,
        airworthiness_area: null,
        reg_port: null,
        gross_tonnage: null,
        net_tonnage: null,
        type: null,
        construct_date: null,
        reconstruct_date: null,
        construct_plant: null,
        reconstruct_plant: null,
        owner: [],
        total_length: null,
        total_width: null,
        depth: null,
        light_displacement: null,
        hull_material: "0",
        load_tonnage: null,
        crew_num: null,
        host_model: null,
        host_type: null,
        host_number: null,
        power: null,
        hk_route: 0,
        sailing_range: null,
        operation_mode: null,
        mmsi: null,
        classification: null,
        flag: null,
        origin_reg_port: null
      },
      type_list: [],
      airworthiness_area_list: [],
      operation_mode_list: [],
      hull_material_list: [],
      file_type_list: [],
      customer_list: [],
      rules: {
        name: [{required: true, message: "请输入船舶名称", trigger: "blur"}],
        reg_port: [{required: true, message: "请输入船籍港", trigger: "blur"}],
        gross_tonnage: [{required: true, message: "请输入总吨位", trigger: "blur"}],
        type: [{required: true, message: "请选择船舶类型", trigger: "blur"}],
        construct_date: [{required: true, message: "请输入建造完工日期", trigger: "blur"}],
        construct_plant: [{required: true, message: "请输入船舶建造地", trigger: "blur"}],
        // owner: [{required: true, message: "请选择船东", trigger: "blur"}],
        airworthiness_area: [{required: true, message: "请选择航区", trigger: "blur"}],
        age: [
          {type: "number", message: "请输入数值类型数据", trigger: "blur"}
        ]
      },
    }
  },
  methods: {
    resetFD() {
      this.fd = {};
    },
    loadData() {
      let p = []
      p.push(fetchDictList({type: "ship.type"}))
      p.push(fetchDictList({type: "ship.airworthiness_area"}))
      p.push(fetchDictList({type: "ship.operation_mode"}))
      p.push(fetchDictList({type: "ship.hull_material"}))
      p.push(fetchFileTypeList({file_type: "sc"}))
      p.push(fetchCustomerList())

      Promise.all(p)
        .then(res => {
          this.type_list = res[0]
          this.airworthiness_area_list = res[1]
          this.operation_mode_list = res[2]
          this.hull_material_list = res[3]
          this.file_type_list = res[4]
          this.customer_list = res[5]
        })
        .catch(error => {
          this.$error_message(error);
        });
    },
    cancelData() {
      this.$refs.dataForm.resetFields()
      this.resetFD()
      this.$router.push({name: "shipList"})
    }
  }
}
